//mypreset.ts
import { definePreset } from '@primeng/themes';
import Material  from '@primeng/themes/Material';
import Aura from '@primeng/themes/Aura';
import Lara from '@primeng/themes/Lara';

const MyPreset = definePreset(Material, {
    semantic: {
        primary: {
            50: '{indigo.50}',
            100: '{indigo.100}',
            200: '{indigo.200}',
            300: '{indigo.300}',
            400: '{indigo.400}',
            500: '{indigo.500}',
            600: '{indigo.600}',
            700: '{indigo.700}',
            800: '{indigo.800}',
            900: '{indigo.900}',
            950: '{indigo.950}'
        }
    }
});

export default MyPreset;
